import { ApprovalMethodNoticePeriodType } from './model';
export const approvalMethodNoticePeriodTextsPath = 'billing.approvalMethodNoticePeriodModel';
export function isAutoApproval(approvalMethod) {
    return approvalMethod.type === ApprovalMethodNoticePeriodType.Automatic;
}
export function noticePeriodDays(amendmentsApprovalMethod) {
    return isAutoApproval(amendmentsApprovalMethod) ? amendmentsApprovalMethod.auto.noticePeriodDays : null;
}
export function isEqual(a, b) {
    return isAutoApproval(a) === isAutoApproval(b) && noticePeriodDays(a) === noticePeriodDays(b);
}
export const amendmentsDescription = (amendmentsApprovalMethod, texts)=>isAutoApproval(amendmentsApprovalMethod) ? texts.amendmentsAutoApproval({
        count: amendmentsApprovalMethod.auto.noticePeriodDays
    }) : texts.amendmentsManualApproval();
export const invoicesDescription = (invoicesApprovalMethod, texts)=>isAutoApproval(invoicesApprovalMethod) ? texts.invoicesAutoApproval({
        count: invoicesApprovalMethod.auto.noticePeriodDays
    }) : texts.invoicesManualApproval();
